import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export default function AirbnbLeadSection() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleConsultationClick = () => {
    navigate('/tokyo-airbnb-support#contact');
  };

  return (
    <section className="relative py-20 overflow-hidden">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#0F4C5C] via-[#1A6B7D] to-[#0F4C5C]"></div>
      
      {/* Decorative overlay */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full mb-6">
          <i className="ri-building-line text-emerald-400"></i>
          <span className="text-sm text-white font-medium">For Property Owners</span>
        </div>

        {/* Main heading */}
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
          {t('home:airbnbLead.title')}
        </h2>

        {/* Description */}
        <p className="text-lg md:text-xl text-white/90 mb-10 max-w-3xl mx-auto leading-relaxed">
          {t('home:airbnbLead.description')}
        </p>

        {/* CTA Button */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={handleConsultationClick}
            className="group inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-emerald-500 to-teal-500 text-white text-lg font-semibold rounded-lg shadow-xl hover:shadow-2xl hover:scale-105 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <span>{t('home:airbnbLead.ctaButton')}</span>
            <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform duration-300"></i>
          </button>
        </div>

        {/* Trust indicators */}
        <div className="mt-12 flex flex-wrap justify-center gap-8 text-white/80 text-sm">
          <div className="flex items-center gap-2">
            <i className="ri-checkbox-circle-fill text-emerald-400"></i>
            <span>{t('home:airbnbLead.badge1')}</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-checkbox-circle-fill text-emerald-400"></i>
            <span>{t('home:airbnbLead.badge2')}</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-checkbox-circle-fill text-emerald-400"></i>
            <span>{t('home:airbnbLead.badge3')}</span>
          </div>
        </div>
      </div>
    </section>
  );
}